export const GET_EXTRACTIONS = "GET_EXTRACTIONS";
